define(function(require) {
    // GEO03E09_ADRS layer definition config
    return {
        LAYER_ID : "GEO03E09_ADRS",
        LAYER_TYPE : "POINT",
        LOADING_MODE : "ON_DEMAND",
        QUERY_EXPRESSION : {
            LOGICAL_OPERATOR : null,
            QUERIES : [{FIELD : undefined, OPERATOR : "IN", VALUE : undefined}]
        },
        INDEX : 25,
        DATATABLE_ID : "t_GEO03E09_ADRS",
        QUERY_FIELDS : ["IDADR", "NOCIVQ", "NOCIVQSUF", "ODORECLG", "CODPOS"],
        FIELDS : [
            {ID : "ID", NAME : "Id", DATA_TYPE : "STRING", VALUE : "{{$UUID$}}"},
            {ID : "IDADR", NAME : "Id Adresse", DATA_TYPE: "STRING", VALUE: "{{IDADR}}"},
            {ID : "NOCIVQ", NAME : "Numéro civique", DATA_TYPE: "STRING", VALUE: "{{NOCIVQ}}"},
            {ID : "NOCIVQSUF", NAME : "Numéro civique suffix", DATA_TYPE: "STRING", VALUE: "{{NOCIVQSUF}}"},
            {ID : "ODORECLG", NAME : "Rue", DATA_TYPE: "STRING", VALUE: "{{ODORECLG}}"},
            {ID : "CODPOS", NAME : "Code postal", DATA_TYPE: "STRING", VALUE: "{{CODPOS}}"}
        ],
        STYLES : [
            {
                ID : "Points d'adresses",
                SYMBOLIZERS : [
                    {
                        SYMBOLIZER_TYPE : "SymbolPointSymbolizer",
                        COLOR : "rgba(255,255,255,1)",
                        FONT_NAME : "CartoVistaCartographic",
                        FONT_FILE_SOURCE : require("fonts/CartoVistaCartographic.ttf"),
                        SYMBOL_CHAR : "=",
                        SIZE : 14,
                        HAS_HALO : true,
                        HALO_COLOR : "rgba(0,0,0,1)"
                    }
                ],
                STYLE_LABEL_PROPERTIES : {
                    BOLD : true,
                    COLOR : "rgba(0,0,0,1)",
                    FONT_NAME : "Arimo-Regular",
                    FONT_FILE_SOURCE : "fonts/externals/Arimo-Regular",
                    HALO_COLOR : "rgba(255,255,255,1)",
                    HAS_HALO_COLOR : true,
                    SIZE : 8,
                    VISIBLE : false
                }
            }
        ],
        LAYER_PROPERTIES : {
            NAME : "Points d'adresses",
            FEATURE_ID_DATACOLUMN : "ID",
            FEATURE_NAME_DATACOLUMN : "IDADR",
            DATATIP_DATACOLUMNS : ["NOCIVQ", "NOCIVQSUF", "ODORECLG", "CODPOS"],
            DATATIP_DATACOLUMNS_DISPLAY_MODE : "NONE",
            DATAVIEW_DATACOLUMNS : ["IDADR", "NOCIVQ", "NOCIVQSUF", "ODORECLG", "CODPOS"],
            DATAVIEW_DATACOLUMNS_DISPLAY_MODE : "NONE",
            INFOVIEW_DATACOLUMNS : ["IDADR", "NOCIVQ", "NOCIVQSUF", "ODORECLG", "CODPOS"],
            INFOVIEW_DATACOLUMN_DISPLAY_MODE : "NONE",
            SEARCHABLE_DATACOLUMNS : ["NOCIVQ", "NOCIVQSUF", "ODORECLG", "CODPOS"],
            IS_VISIBLE_IN_LAYER_CONTROL : false,
            IS_VISIBLE_IN_LEGEND : false,
            SHOW_STYLES_IN_LAYER_CONTROL : false,
            //LABEL_DATACOLUMN : null
            VISIBLE : true,
            ZOOM_ON_FEATURE_SCALE : 6000
        }
    };
});
